// Enum to define the allowed time periods
export enum TimePeriod {
  All = "ALL",
  Future_Only = "future",
  Active_Only = "0",
  Three_Days_Ended = "3",
  Fourteen_Days_Ended= "14",
  Thirty_Days_Ended = "30",
}
